import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "@nuxtjs/composition-api";
import { toCurrencyFormat } from "@/core/helpers/GlobalHelpers";
import Asset from "~/pages/finances/wallet/models/Asset";

interface Props {
    total?: number;
    priceData: Array<Asset>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Total',
  props: {
    total: { default: 0 },
    priceData: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { total: number, priceData: Array<Asset> };



const {
    total,
    priceData,
} = toRefs(props);

return { __sfc: true,props, total, priceData, toCurrencyFormat }
}

})